/* Scripts do cart-drawer extraídos do inline (snippets/cart-drawer.liquid) para asset cacheável. Config em window.ThemeCartCfg. */


(() => {
  'use strict';

  const mqMobile  = window.matchMedia('(max-width: 749px)');
  const inited    = new WeakSet();

  // Clique no card (imagem + infos) → navega
  document.addEventListener('click', function(e){
    const mainButton = e.target.closest('.cart-drawer__recommendation-main');
    if (mainButton) {
      const url = mainButton.getAttribute('data-product-url');
      if (url) window.location.href = url;
    }
  }, { passive: true });

  // ===== Setup global =====
  function refreshAll(){
    const lists = document.querySelectorAll('[data-reco-list]');
    lists.forEach(setupOrRefresh);
    requestAnimationFrame(() => lists.forEach(normalizeTitles));
  }

  function setupOrRefresh(list){
    if (!list) return;
    if (!inited.has(list)) {
      bindList(list);
      inited.add(list);
    }
    const nav = findNavForList(list);
    if (nav) {
      rebuildDots(nav, list);
      updateDots(nav, list);
      toggleNavVisibility(nav);
    }
    normalizeTitles(list);
  }

  function bindList(list){
    const nav = findNavForList(list);

    // Atualiza dots suavemente durante o scroll (mobile)
    let scrollRAF = null;
    list.addEventListener('scroll', () => {
      if (!mqMobile.matches) return;
      if (scrollRAF) return;
      scrollRAF = requestAnimationFrame(() => {
        scrollRAF = null;
        if (nav) updateDots(nav, list);
      });
    }, { passive: true });

    // Resize
    window.addEventListener('resize', debounce(() => {
      if (nav) {
        rebuildDots(nav, list);
        updateDots(nav, list);
        toggleNavVisibility(nav);
      }
      normalizeTitles(list);
    }, 120), { passive: true });

    // Setas
    if (nav) bindArrows(nav, list);

    // Breakpoint
    mqMobile.addEventListener('change', () => { if (nav) toggleNavVisibility(nav); });
  }

  function findNavForList(list){
    const root = list.closest('.cart-drawer__recommendations-column') || document;
    return root.querySelector('[data-reco-nav]') || null;
  }

  function rebuildDots(nav, list){
    const dotsWrap = nav.querySelector('[data-reco-dots]');
    if (!dotsWrap) return;
    const slides = list.querySelectorAll('.reco-slide');

    const frag = document.createDocumentFragment();
    slides.forEach((_, idx) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'reco-dot';
      b.setAttribute('aria-label', 'Ir para item ' + (idx + 1));
      b.addEventListener('click', () => {
        const slide = slides[idx];
        list.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
      frag.appendChild(b);
    });
    dotsWrap.replaceChildren(frag);
  }

  function updateDots(nav, list){
    const dots   = nav.querySelectorAll('.reco-dot');
    const slides = list.querySelectorAll('.reco-slide');
    if (!dots.length || !slides.length) return;

    const center = list.scrollLeft + list.clientWidth / 2;
    let active = 0, best = Infinity;

    slides.forEach((s, i) => {
      const mid = s.offsetLeft + s.offsetWidth / 2;
      const d   = Math.abs(mid - center);
      if (d < best) { best = d; active = i; }
    });

    dots.forEach((d, i) => d.classList.toggle('is-active', i === active));
  }

  function bindArrows(nav, list){
    const prev = nav.querySelector('[data-reco-prev]');
    const next = nav.querySelector('[data-reco-next]');
    prev?.addEventListener('click', () => list.scrollBy({ left: -list.clientWidth * 0.9, behavior: 'smooth' }));
    next?.addEventListener('click', () => list.scrollBy({ left:  list.clientWidth * 0.9, behavior: 'smooth' }));
  }

  function toggleNavVisibility(nav){
    nav.style.display = mqMobile.matches ? '' : 'none';
  }

  function normalizeTitles(list){
    const titles = list.querySelectorAll('.cart-drawer__recommendation-title');
    if (!titles.length) return;
    titles.forEach(t => t.style.minHeight = '');
    let maxH = 0;
    titles.forEach(t => { maxH = Math.max(maxH, t.offsetHeight); });
    list.style.setProperty('--reco-title-height', (maxH || 0) + 'px');
    titles.forEach(t => t.style.minHeight = 'var(--reco-title-height)');
  }

  // ====== Observer: reconstrói recomendações/dots após mudanças do carrinho ======
  const drawer = document.querySelector('.cart-drawer__dialog');
  if (drawer){
    let raf = null;
    const moDrawer = new MutationObserver((muts) => {
      const meaningful = muts.some(m =>
        m.type === 'childList' &&
        ([...m.addedNodes, ...m.removedNodes].some(n =>
          n.nodeType === 1 && (
            n.matches?.('cart-items-component, .cart-drawer__items, .cart-drawer__cart-column, [data-reco-list]')
          )
        ))
      );
      if (!meaningful) return;
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = null; refreshAll(); });
    });
    moDrawer.observe(drawer, { childList: true, subtree: true });
  }

  // Boot
  if (document.readyState !== 'loading') refreshAll();
  else document.addEventListener('DOMContentLoaded', refreshAll, { once: true });

  function debounce(fn, wait){ let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), wait); }; }
})();


/* ---- */


(()=> {
  // Helper: formata dinheiro com a moeda da loja
  const money = (cents) => {
  const SHOP_CURRENCY   = (window.ThemeCartCfg || {}).shopCurrency;
  const ACTIVE_CURRENCY = window.Currency?.currentCurrency || window.Shopify?.currency?.active || (window.ThemeCartCfg || {}).activeCurrency;

  // Se o tema tiver Currency.js, converte de fato
  let amount = Number(cents) || 0;
  if (window.Currency && typeof Currency.convert === 'function') {
    try {
      amount = Math.round(Currency.convert(amount / 100, SHOP_CURRENCY, ACTIVE_CURRENCY) * 100);
    } catch { /* mantém amount */ }
  }

  try {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      const fmt =
        window.Shopify?.currency?.format ||
        window.theme?.moneyFormat ||
        window.Shopify?.money_format ||
        (window.ThemeCartCfg || {}).moneyFormat;
      return Shopify.formatMoney(amount, fmt);
    }
  } catch {}

  // Fallback apenas de formatação
  return (amount/100).toLocaleString(undefined, { style:'currency', currency: ACTIVE_CURRENCY || SHOP_CURRENCY || 'USD' });
};

  const qa = document.querySelector('[data-reco-qa]');
  if (!qa) return;

  const el = {
    wrap: qa,
    panel: qa.querySelector('.reco-quickadd__panel'),
    closeBtns: qa.querySelectorAll('[data-reco-qa-close]'),
    thumb: qa.querySelector('[data-qa-thumb]'),
    title: qa.querySelector('[data-qa-title]'),
    form: qa.querySelector('[data-qa-form]'),
    opts: qa.querySelector('[data-qa-options]'),
    qtyWrap: qa.querySelector('.reco-quickadd__qty'),
    status: qa.querySelector('[data-qa-status]'),
    submit: qa.querySelector('[data-qa-submit]')
  };

  // Garante nós do cabeçalho (título + faixa de preço)
  function ensureTitleScaffold(){
    if (!el.title) return;
    let t = el.title.querySelector('.qa-title-text');
    let p = el.title.querySelector('.qa-price-line');
    if (!t){
      t = document.createElement('span');
      t.className = 'qa-title-text';
      el.title.appendChild(t);
    }
    if (!p){
      p = document.createElement('div');
      p.className = 'qa-price-line';
      el.title.appendChild(p);
    }
    el.titleText = t;
    el.priceLine = p;
  }
  ensureTitleScaffold();

  // ==== helpers de imagem ====
  function addWidthParam(url, width){
    try {
      const u = new URL(url, window.location.origin);
      // evita duplicar
      if (!u.searchParams.has('width')) u.searchParams.set('width', String(width));
      return u.toString();
    } catch { return url; }
  }
  function normalizeUrl(url){
    if (!url) return '';
    if (url.startsWith('//')) return window.location.protocol + url;
    if (url.startsWith('http')) return url;
    // caso venha relativo
    return new URL(url, window.location.origin).toString();
  }
  function getVariantImageUrl(variant, product){
    // Tenta featured_image.src do variant
    let src = variant?.featured_image?.src || variant?.featured_image?.url || '';
    if (!src) {
      // fallback: usa primeira imagem do produto
      src = product?.images?.[0] || '';
    }
    src = normalizeUrl(src);
    // Ajusta tamanho (Shopify CDN aceita ?width=)
    src = addWidthParam(src, 320);
    return src;
  }
  function updateThumbForVariant(variant){
    const url = getVariantImageUrl(variant, productJson);
    if (!url) return; // mantém o que já está
    const alt = (productJson?.title || '').replace(/"/g, '&quot;');
    el.thumb.innerHTML = `<img src="${url}" alt="${alt}" />`;
  }

  let productJson = null;
  let selected = {};
  let activeVariant = null;

  function openQA() {
    if (el.submit) el.submit.style.fontSize = '1.1rem';
    if (el.qtyWrap) el.qtyWrap.style.display = 'none'; // sempre 1 un.
    qa.hidden = false;
    qa.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeQA() {
    qa.hidden = true;
    qa.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    el.opts.innerHTML = '';
    el.status.textContent = '';
    ensureTitleScaffold();
    el.titleText.textContent = '';
    el.priceLine.innerHTML = '';
    el.submit.disabled = true;
    productJson = null; selected = {}; activeVariant = null;
  }

  el.closeBtns.forEach(b => b.addEventListener('click', closeQA));
  document.addEventListener('keydown', (ev) => { if (ev.key === 'Escape' && !qa.hidden) closeQA(); });

  // Clique nos CTAs (adicionar direto x abrir Quick Add)
  document.addEventListener('click', async (e) => {
    const cta = e.target.closest('.cart-drawer__recommendation-cta');
    if (!cta) return;
    e.preventDefault();

    const directId = cta.getAttribute('data-direct-variant-id');
    const handle   = cta.getAttribute('data-product-handle');

    // Adicionar direto (1 variante)
    if (directId) {
      const original = cta.textContent;
      cta.disabled = true;
      cta.setAttribute('aria-busy', 'true');
      cta.textContent = (window.ThemeCartCfg || {}).txtBotao5;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: [{ id: Number(directId), quantity: 1 }] }),
          credentials: 'same-origin'
        });
        if (!res.ok) {
          let txt = await res.text(); let payload;
          try { payload = JSON.parse(txt); } catch { payload = { message: txt }; }
          cta.textContent = 'Tente novamente';
          cta.disabled = false;
          cta.removeAttribute('aria-busy');
          console.warn('add.js erro:', payload);
          return;
        }
        cta.textContent = (window.ThemeCartCfg || {}).txtBotao6;
        await refreshCartSections();
      } catch(err) {
        console.error('Erro ao adicionar direto:', err);
        cta.textContent = 'Tente novamente';
        cta.disabled = false;
        cta.removeAttribute('aria-busy');
      } finally {
        setTimeout(() => {
          cta.textContent = (window.ThemeCartCfg || {}).txtBotao;
          cta.disabled = false;
          cta.removeAttribute('aria-busy');
        }, 900);
      }
      return;
    }

    // Quick Add (múltiplas opções)
    if (!handle) return;

    // Fallback visual imediato (card) enquanto busca JSON
    ensureTitleScaffold();
    const card  = cta.closest('.reco-slide, .cart-drawer__recommendation');
    const img   = card?.querySelector('img')?.currentSrc || card?.querySelector('img')?.src;
    const titleFallback = card?.querySelector('.cart-drawer__recommendation-title')?.textContent?.trim() || '';
    el.thumb.innerHTML = img ? `<img src="${img}" alt="">` : '';
    el.titleText.textContent = titleFallback;
    el.priceLine.innerHTML = '';

    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
      productJson = await res.json();

      // Título oficial do produto
      el.titleText.textContent = productJson?.title || titleFallback || '';

      buildOptions(productJson);
      pickFirstAvailable(); // vai atualizar preço e thumb
      openQA();
    } catch(err) {
      console.error('QuickAdd: falha ao carregar produto', err);
    }
  });

  async function refreshCartSections(){
    ['cart:refresh','cart:updated','cart:change','theme:cart:refresh'].forEach(n => {
      window.dispatchEvent(new CustomEvent(n));
      document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
    });
    const sectionId = document.querySelector('cart-items-component')?.dataset.sectionId;
    if (!sectionId) return;
    try {
      const html = await fetch(`${location.pathname}?section_id=${sectionId}`, { credentials:'same-origin' }).then(r => r.text());
      const tmp = document.createElement('div'); tmp.innerHTML = html;
      const newCartCol = tmp.querySelector('.cart-drawer__cart-column');
      const curCartCol = document.querySelector('.cart-drawer__cart-column');
      if (newCartCol && curCartCol) curCartCol.replaceWith(newCartCol);
      const newRecoCol = tmp.querySelector('.cart-drawer__recommendations-column');
      const curRecoCol = document.querySelector('.cart-drawer__recommendations-column');
      if (newRecoCol && curRecoCol) curRecoCol.replaceWith(newRecoCol);
      if (typeof refreshAll === 'function') refreshAll();

      if (typeof window.__convertDrawerPrices === 'function') {
  window.__convertDrawerPrices(document);
}

    } catch(e) {
      console.warn('Fallback: reload page after add', e);
      location.reload();
    }
  }

  // ====== Opções / variantes ======
  function buildOptions(p) {
    el.opts.innerHTML = '';
    selected = {};
    const optNames = (p.options || []).map(o => typeof o === 'string' ? o : o?.name).filter(Boolean);
    optNames.forEach((optName, idx) => {
      const id = `qa-opt-${idx}`;
      const wrap = document.createElement('div');
      wrap.innerHTML = `
        <label for="${id}">${escapeHtml(optName)}</label>
        <select id="${id}" data-opt-index="${idx}" aria-label="${escapeHtml(optName)}" style="font-size:1.1rem; padding:.6rem .7rem;"></select>
      `;
      const sel = wrap.querySelector('select');
      sel.addEventListener('change', () => recomputeFrom(0));
      el.opts.appendChild(wrap);
    });
    recomputeFrom(0);
  }

  function pickFirstAvailable() {
    const firstAvail = (productJson?.variants || []).find(v => v.available) || productJson?.variants?.[0];
    if (!firstAvail) return;
    const selects = el.opts.querySelectorAll('select[data-opt-index]');
    selects.forEach((sel, i) => {
      const val = firstAvail[`option${i+1}`];
      if (!val) return;
      if (!Array.from(sel.options).some(o => o.value == val)) {
        recomputeFrom(0);
      }
      const opt = Array.from(sel.options).find(o => o.value == val);
      if (opt) sel.value = opt.value;
    });
    recomputeFrom(0); // garante atualização de preço e thumb
  }

  function recomputeFrom(startIdx) {
    const p = productJson || {};
    const variants = p.variants || [];
    const optNames = (p.options || []).map(o => typeof o === 'string' ? o : o?.name).filter(Boolean);
    const selects = Array.from(el.opts.querySelectorAll('select[data-opt-index]')).sort((a,b)=>a.dataset.optIndex-b.dataset.optIndex);

    let currentSel = {};
    selects.forEach((sel, i) => { currentSel[optNames[i]] = sel.value; });

    for (let i = 0; i < optNames.length; i++) {
      const name = optNames[i];
      const allowed = new Set();
      variants.forEach(v => {
        let ok = true;
        for (let j = 0; j < i; j++) {
          const prevName = optNames[j];
          if (currentSel[prevName] && String(v[`option${j+1}`]) !== String(currentSel[prevName])) { ok = false; break; }
        }
        if (ok) allowed.add(String(v[`option${i+1}`]));
      });
      const values = Array.from(allowed);
      const sel = selects[i];
      const prevVal = currentSel[name];
      sel.innerHTML = values.map(v => `<option value="${escapeHtml(v)}">${escapeHtml(v)}</option>`).join('');
      if (values.includes(prevVal)) sel.value = prevVal; else sel.value = values[0] || '';
      currentSel[name] = sel.value;
    }

    selected = { ...currentSel };
    const match = variants.find(v => optNames.every((n, i) => String(v[`option${i+1}`]) === String(selected[n])));
    activeVariant = match || null;

    if (!activeVariant) {
      ensureTitleScaffold();
      el.priceLine.innerHTML = '';
      el.status.textContent = 'Esta combinação não existe.';
      el.submit.disabled = true;
      return;
    }

    // Atualiza preço e thumb SEMPRE aqui
    ensureTitleScaffold();
    updatePriceLine(activeVariant);
    updateThumbForVariant(activeVariant);

    if (!activeVariant.available) {
      el.status.textContent = 'Indisponível no momento.';
      el.submit.disabled = true;
    } else {
      el.status.textContent = '';
      el.submit.disabled = false;
    }
  }

  function updatePriceLine(variant) {
    if (!variant) return;
    const currentCents = Number(variant.price) || 0;
    const compareCents = Number(variant.compare_at_price) || 0;
    const priceHtml   = `<span class="qa-price__current" style="font-weight:700;">${money(currentCents)}</span>`;
    const compareHtml = (compareCents > currentCents)
      ? `<span class="qa-price__compare" style="font-size:.92em; text-decoration:line-through; opacity:.7; margin-left:.4rem;">${money(compareCents)}</span>`
      : '';
    el.priceLine.innerHTML = `${priceHtml} ${compareHtml}`;
  }

  // Submit: adiciona SEMPRE 1 unidade
  el.form.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    if (!activeVariant) return;
    el.submit.disabled = true;
    const originalLabel = el.submit.textContent;
    el.submit.textContent = (window.ThemeCartCfg || {}).txtBotao5;
    el.status.textContent = '';
    try {
      const body = { items: [{ id: Number(activeVariant.id), quantity: 1 }] };
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body),
        credentials: 'same-origin'
      });
      if (!res.ok) {
        let t = await res.text(); let payload;
        try { payload = JSON.parse(t); } catch { payload = { message: t }; }
        const msg = (payload?.description || payload?.message || '').toLowerCase();
        el.status.textContent = (res.status === 422 && /selling[_ ]?plan/.test(msg))
          ? 'Este produto requer um plano de assinatura. Selecione o plano antes de adicionar.'
          : (payload?.description || payload?.message || 'Não foi possível adicionar. Tente novamente.');
        el.submit.disabled = false;
        el.submit.textContent = originalLabel || (window.ThemeCartCfg || {}).txtBotao4;
        return;
      }
      el.submit.textContent = (window.ThemeCartCfg || {}).txtBotao4;
      setTimeout(closeQA, 150);

      // Atualiza drawer
      ['cart:refresh','cart:updated','cart:change','theme:cart:refresh'].forEach(n => {
        window.dispatchEvent(new CustomEvent(n));
        document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
      });
      const sectionId = document.querySelector('cart-items-component')?.dataset.sectionId;
      if (sectionId) {
        try {
          const html = await fetch(`${location.pathname}?section_id=${sectionId}`, { credentials: 'same-origin' }).then(r => r.text());
          const tmp = document.createElement('div'); tmp.innerHTML = html;
          const newCartCol = tmp.querySelector('.cart-drawer__cart-column');
          const curCartCol = document.querySelector('.cart-drawer__cart-column');
          if (newCartCol && curCartCol) curCartCol.replaceWith(newCartCol);
          const newRecoCol = tmp.querySelector('.cart-drawer__recommendations-column');
          const curRecoCol = document.querySelector('.cart-drawer__recommendations-column');
          if (newRecoCol && curRecoCol) curRecoCol.replaceWith(newRecoCol);
          if (typeof refreshAll === 'function') refreshAll();
        } catch (e) {
          console.warn('Fallback: reload page after add', e);
          location.reload();
        }
      }
    } catch (err) {
      console.error('Erro no add.js:', err);
      el.status.textContent = 'Erro de rede. Tente novamente.';
      el.submit.disabled = false;
      el.submit.textContent = originalLabel || (window.ThemeCartCfg || {}).txtBotao4;
    }
  });

  function escapeHtml(s){ return String(s).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m])); }
})();


/* ---- */


(() => {
  // Moedas de referência vindas do Liquid
  const SHOP_CURRENCY   = (window.ThemeCartCfg || {}).shopCurrency;
  const ACTIVE_CURRENCY = window.Shopify?.currency?.active || (window.ThemeCartCfg || {}).activeCurrency;

  // Tenta usar o conversor do tema (Currency.js); fallback formata sem converter
  function convertCents(cents) {
    const n = Number(cents) || 0;
    if (window.Currency && typeof Currency.convert === 'function' && Currency.currentCurrency) {
      const from = SHOP_CURRENCY;
      const to   = window.Currency.currentCurrency || ACTIVE_CURRENCY || from;
      try {
        // Currency.convert trabalha em "unidades", então divide/ multiplica por 100
        const units = n / 100;
        const conv  = Currency.convert(units, from, to);
        return Math.round(conv * 100);
      } catch { /* segue fallback */ }
    }
    // Se não houver conversor, mantém o valor
    return n;
  }

  function moneyFormat() {
    // Usa formato do tema/loja
    return (
      window.Shopify?.currency?.format ||
      window.theme?.moneyFormat ||
      window.Shopify?.money_format ||
      (window.ThemeCartCfg || {}).moneyFormat
    );
  }

  function formatCents(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat());
      }
    } catch {}
    // Fallback simples com Intl (apenas formata; não converte)
    const curr = window.Currency?.currentCurrency || ACTIVE_CURRENCY || SHOP_CURRENCY || 'USD';
    return (cents/100).toLocaleString(undefined, { style:'currency', currency: curr });
  }

  function updateOne(el) {
    const centsAttr = el.getAttribute('data-cents');
    if (!centsAttr) return;
    const converted = convertCents(centsAttr);
    el.textContent = formatCents(converted);
  }

  // Converte todos os preços no drawer (recomendados)
  function convertDrawerPrices(root = document) {
    const targets = root.querySelectorAll('.cart-drawer__recommendations-column .money[data-cents]');
    targets.forEach(updateOne);
  }

  // Exponha global p/ ser chamado após replace de seção
  window.__convertDrawerPrices = convertDrawerPrices;

  // Rodar agora e ao abrir/atualizar o carrinho
  if (document.readyState !== 'loading') convertDrawerPrices();
  else document.addEventListener('DOMContentLoaded', () => convertDrawerPrices(), { once: true });

  // Alguns temas disparam eventos de troca de moeda/país
  ['currency:change','theme:currency:change','shopify:section:load','cart:refresh','cart:updated']
    .forEach(evt => document.addEventListener(evt, () => convertDrawerPrices(), { passive: true }));

  // Também observa mudanças no drawer (quando a coluna é re-renderizada)
  const drawer = document.querySelector('.cart-drawer__dialog');
  if (drawer) {
    const mo = new MutationObserver((muts) => {
      const changed = muts.some(m =>
        m.type === 'childList' &&
        [...m.addedNodes].some(n => n.nodeType === 1 && n.closest?.('.cart-drawer__recommendations-column'))
      );
      if (changed) convertDrawerPrices(drawer);
    });
    mo.observe(drawer, { childList:true, subtree:true });
  }
})();
